import styled from 'styled-components';

import { Modal } from 'components/ui';

export const StyledModal = styled(Modal)`
  .ant-modal-body {
    max-height: 60vh;
    overflow-y: auto;
  }

  /* Neutralize AttributesForm's nested scroll so the body scrolls as one. */
  .ant-modal-body > div:has(> form),
  .ant-modal-body form,
  .ant-modal-body .form-fields-container {
    height: auto;
    max-height: none;
    overflow: visible;
  }

  .ant-modal-body .form-fields-container + * {
    display: none;
  }

  .ant-modal-footer .ant-btn + .ant-btn {
    margin-left: 8px;
  }
`;
